import React, { useState, useEffect, useContext, useRef } from 'react';
import { WalletContext } from '../context/WalletContext';
import { VENUES } from '../components/TradeController/constants';
import TradeController from '../components/TradeController/TradeController';
import PortfolioPanel from '../components/TradeController/PortfolioPanel';
import '../style/components/TradeController.scss';

const API_BASE = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'http://localhost:3003'
  : 'https://api.blockhivetechnologies.com';

export default function Trade() {
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    // Accept token passed via hash from client dashboard launchTrade()
    const hashMatch = window.location.hash.match(/[#&]t=([^&]+)/);
    if (hashMatch) {
      localStorage.setItem('auth_token', decodeURIComponent(hashMatch[1]));
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    const token = localStorage.getItem('auth_token');
    if (!token) { window.location.href = '/trade-login.html'; return; }
    fetch(`${API_BASE}/auth/check`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        if (r.ok) setAuthed(true);
        else { localStorage.removeItem('auth_token'); window.location.href = '/trade-login.html'; }
      })
      .catch(() => setAuthed(true));
  }, []);

  const { chainId } = useContext(WalletContext);
  const [venue, setVenue] = useState('hyperliquid');
  const venueFollowedChain = useRef(false);

  /*
   * Open on the venue that matches the wallet's current chain.
   *
   * Selecting a venue now asks the wallet to switch to that venue's chain, so a
   * fixed default contradicts itself on load: the HYPE tab renders active while
   * the wallet sits on Arbitrum, and every on-chain read in that panel comes back
   * empty because it is pointed at the wrong network.
   *
   * Once only, on the first chainId we see. Re-running on every change would drag
   * the tab back whenever a switch is declined, and would fight the click handler
   * mid-switch.
   */
  useEffect(() => {
    if (venueFollowedChain.current || !chainId) return;
    const match = VENUES.find(v => !v.disabled && v.chainId === chainId);
    venueFollowedChain.current = true;
    if (match) setVenue(match.id);
  }, [chainId]);

  if (!authed) return null;

  const BTN = {
    background: '#383838', color: '#aaa', border: '1px solid #444',
    borderRadius: '3px', padding: '2px 8px', fontSize: '9px',
    cursor: 'pointer', letterSpacing: '0.5px',
    fontFamily: 'inherit', lineHeight: 'normal',
    position: 'fixed', top: '10px', left: '10px', zIndex: 100,
  };

  return (
    <div className="page-trade">
      <button style={BTN} onClick={() => window.location.href = '/clients/index.html'}>
        ← DASHBOARD
      </button>
      <iframe
        className="tpo-frame"
        src="/tpo_vp.html"
        title="VP / TPO"
        frameBorder="0"
        scrolling="no"
      />
      <TradeController venue={venue} setVenue={setVenue} />
      <PortfolioPanel venue={venue} />
    </div>
  );
}
